/** Default max length for sidebar conversation titles derived from the first user message. */
export const CONVERSATION_TITLE_MAX_LENGTH = 60;

/**
 * Builds a sidebar-friendly conversation title from the first user message.
 * Collapses whitespace and truncates with an ellipsis when over {@link CONVERSATION_TITLE_MAX_LENGTH}.
 *
 * @param message - Raw user message text.
 * @param maxLength - Character limit before truncation (default 60).
 * @returns A non-empty title suitable for `POST /conversation/create`.
 */
export function deriveConversationTitle(
  message: string,
  maxLength = CONVERSATION_TITLE_MAX_LENGTH
): string {
  const singleLine = message.replace(/\s+/g, ' ').trim();
  if (!singleLine) {
    return 'New conversation';
  }
  if (singleLine.length <= maxLength) {
    return singleLine;
  }
  return `${singleLine.slice(0, maxLength - 1).trimEnd()}…`;
}
